import { NgModule, ModuleWithProviders } from '@angular/core'
import { AuthService } from './services/auth.service'
import { AuthGuardService } from './services/auth-guard.service'
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt'
import { JwtModule } from '@auth0/angular-jwt'


@NgModule({
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [AuthService, JwtModule, AuthGuardService]
    }
  }
}
